import React from "react"
import PropTypes from "prop-types"
import { withApi } from "@tencent/react-aio"
import WithPermission from "@/common/permissions/WithPermission"
import { Button, OverlayTrigger, PopOver, ImageUploader } from "@tencent/spaui"
import EditOrderModal from "./EditOrderModal"
import Delegate from "@/components/Delegate"
import MessageBox from "@/components/MessageBox"
import _ from "lodash"
import AttachmentLinks from "@/components/AttachmentLinks"
import { getMessage } from "@/utils/MessageUtils"
import PaymentReviewModal from "./PaymentReviewModal"
import PaymentRejectModal from "./PaymentRejectModal"
import DateTime from "@/components/DateTime"
import OnlineReviewModal from "./OnlineReviewModal"
import SubmittedOnlineModal from "./SubmittedOnlineModal"
import fePerms from "@/common/permissions/sale/fePerms"
import { isContain } from "@/utils/ParamUtils"
import Money from "@/components/Money"
import ContractMethod from "@/components/ContractMethod"
import OrderingProduct from "@/business-components/sale/OrderingProduct"
import { getQuery } from "@/utils"

class OrderPanel extends React.Component {
  static propTypes = {
    readOnly: PropTypes.bool,
    onEdit: PropTypes.func,
    onChange: PropTypes.func,
  }

  state = {
    orderInfo: {},
    contractImages: [],
    remittanceImages: [],
    orderApplyRecord: {},
    customerId: "",
    customerMpUserName: "",
  }

  constructor(props) {
    super(props)
    this.editOrderModal = React.createRef()
    this.onlineReviewModal = React.createRef()
    this.paymentReviewModal = React.createRef()
    this.paymentRejectModal = React.createRef()
    this.submittedOnlineModal = React.createRef()
  }
  componentDidMount() {
    this.fetchOrder()
  }
  fetchOrder() {
    const {
      webApi,
      lead: { leadId },
    } = this.props
    const agencyId = getQuery("agencyId")
    webApi
      .getOrder(leadId, agencyId)
      .ajax()
      .then(
        (res) => {
          this.setState({
            orderInfo: res,
          })
          this.setRemittanceImages()
          this.setContractImages()
          this.setOrderApplyRecord()
          this.setCustomer()
        },
        (error) => {
          this.context.error("订单详情获取失败", error.message)
        }
      )
  }
  setCustomer() {
    const lead = this.state.orderInfo.lead
    if (lead) {
      this.setState({
        customerId: lead.customerId,
        customerMpUserName: lead.customerMpUserName,
      })
    }
  }
  setOrderApplyRecord() {
    const orderApplyRecord = this.state.orderInfo.orderApplyRecord
    if (orderApplyRecord) {
      this.setState({
        orderApplyRecord: orderApplyRecord,
      })
    }
  }
  setRemittanceImages() {
    const remittanceVoucherAttachmentList = this.state.orderInfo.remittanceVoucherAttachmentList
    if (remittanceVoucherAttachmentList) {
      const remittanceImages = remittanceVoucherAttachmentList.map(function (a) {
        return { url: a.url, name: a.attachmentName, id: a.attachmentId, contentType: a.contentType }
      })
      this.setState({
        remittanceImages: remittanceImages,
      })
    }
  }
  setContractImages() {
    const contractVoucherAttachmentList = this.state.orderInfo.contractVoucherAttachmentList
    if (contractVoucherAttachmentList) {
      const contractImages = contractVoucherAttachmentList.map(function (a) {
        return { url: a.url, name: a.attachmentName, id: a.attachmentId, contentType: a.contentType }
      })
      this.setState({
        contractImages: contractImages,
      })
    }
  }
  render() {
    const { readOnly } = this.props
    const {
      orderInfo: {
        firstPaymentAmount,
        serviceFee,
        contractMethod,
        orderingProductIds,
        remittanceAccount,
        remittanceAccountName,
        contractNo,
        permissions,
      },
    } = this.state;
    const { remittanceImages, contractImages } = this.state
    return (
      <div className="OrderPanel">
        <h2>提单信息</h2>
        <div className="action-bar">
          <WithPermission reject={readOnly}>
            <Button displayType={"primary"} size={"small"} onEdit={this.handleEdit} onClick={this.showEditOrderModal}>
              编辑
            </Button>
          </WithPermission>
          <WithPermission reject={!isContain(permissions, fePerms.ORDER_PAYMENT_REVIEW)}>
            <Button displayType={"primary"} size={"small"} onClick={this.alreadyPaid}>
              到款审核
            </Button>
          </WithPermission>
          {this.state.orderInfo.orderStatus === "ORDER_STATUS_PAID" && (
            <Button displayType={"primary"} size={"small"} onClick={this.orderReject}>
              到款驳回
            </Button>
          )}
          <WithPermission reject={!isContain(permissions, fePerms.ORDER_SUBMIT_ONLINE_REVIEW)}>
            <Button displayType={"primary"} size={"small"} onClick={this.submittedOnline}>
              提交上线
            </Button>
          </WithPermission>
          <WithPermission reject={!isContain(permissions, fePerms.ORDER_ONLINE_REVIEW)}>
            <Button displayType={"primary"} size={"small"} onClick={this.showOnlineReviewModal}>
              上线审核
            </Button>
          </WithPermission>
        </div>
        <dl>
          <dt>首次到款金额：</dt>
          <dd>
            <Money value={firstPaymentAmount} />
          </dd>
          <dt>服务费：</dt>
          <dd>
            <Money value={serviceFee} />
          </dd>
          <dt>广告费：</dt>
          <dd>
            <Money value={firstPaymentAmount - serviceFee} />
          </dd>
          <dt>成单方式：</dt>
          <dd>
            <ContractMethod contractMethod={contractMethod} />
          </dd>
          <dt>下单产品：</dt>
          <dd>
            <OrderingProduct id={orderingProductIds} />
          </dd>
          <dt>汇款账户：</dt>
          <dd>{remittanceAccount}</dd>
          <dt>汇款账户名：</dt>
          <dd>{remittanceAccountName}</dd>
          <dt>合同编号：</dt>
          <dd>{contractNo}</dd>
          <dt>合同凭证：</dt>
          <dd>
            <AttachmentLinks attachments={contractImages} />
          </dd>
          <dt>汇款凭证：</dt>
          <dd>
            <AttachmentLinks attachments={remittanceImages} />
          </dd>
        </dl>
        <Delegate ref={this.editOrderModal} orderInfo={this.state.orderInfo} component={EditOrderModal} />
        <Delegate ref={this.onlineReviewModal} component={OnlineReviewModal} />
        <Delegate ref={this.paymentReviewModal} component={PaymentReviewModal} />
        <Delegate ref={this.paymentRejectModal} component={PaymentRejectModal} />
        <Delegate ref={this.submittedOnlineModal} component={SubmittedOnlineModal} setStateValue={this.setStateValue} />
      </div>
    )
  }

  setStateValue = (key, value) => {
    this.setState({ [key]: value })
  }

  handleEdit = () => {
    const { history } = this.props
    const pathname = history.location.pathname
    history.push({ pathname: pathname + "/update" })
  }

  showEditOrderModal = () => {
    const { webApi, order, onChange } = this.props
    this.editOrderModal.current.show({
      webApi: webApi,
      order: order,
      onSubmit: () => {
        this.fetchOrder()
        onChange && onChange()
      },
    })
  }

  showOnlineReviewModal = () => {
    const { onChange } = this.props
    const { orderInfo } = this.state
    this.onlineReviewModal.current.show({
      orderInfo: orderInfo,
      version: orderInfo.version,
      onSubmit: () => {
        this.fetchOrder()
        onChange && onChange()
      },
    })
  }

  alreadyPaid = () => {
    const { onChange } = this.props
    const { orderInfo } = this.state
    this.paymentReviewModal.current.show({
      orderInfo: orderInfo,
      version: orderInfo.version,
      onSubmit: () => {
        this.fetchOrder()
        onChange && onChange()
      },
    })
  }

  orderReject = () => {
    const { onChange } = this.props
    const { orderInfo } = this.state
    this.paymentRejectModal.current.show({
      orderInfo: orderInfo,
      version: orderInfo.version,
      onSubmit: () => {
        this.fetchOrder()
        onChange && onChange()
      },
    })
  }

  submittedOnline = () => {
    const { onChange } = this.props
    const { orderInfo } = this.state
    this.submittedOnlineModal.current.show({
      order: orderInfo,
      version: orderInfo.version,
      onSubmit: () => {
        this.fetchOrder()
        onChange && onChange()
      },
    })
  }
}

export default withApi(OrderPanel)

OrderPanel.contextType = MessageBox
